<template>
    <div class="page-class"
        :class="{'farmer': userType == 'farmer', 'subdist': userType == 'subdist', 'dist': userType == 'dist', 'sale': userType == 'sale'}">
        <div class="page-wrapper">
            <div class="page-content"
                v-if="isAccountLoaded">
                <nav-bar
                    :pageName="navbarName"
                    :userType="userType"
                    :isShowBack="true"
                    @clickBack="clickBack"></nav-bar>
                <pdpa id="terms_pdpa" :lblCode="lblCode" :hideTabToBottom="true"></pdpa>
            </div>

            <div class="page-bg"></div>
            <!-- <cookie-consent-bar></cookie-consent-bar> -->
        </div>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
//helper
import Locale from '@/helper/locale/locale.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
//component
import Pdpa from "@/components/PDPA/Page/PDPA.vue";
import NavBar from "@/components/Layout/NavBar/NavBar.vue";

// import CookieConsentBar from '@/components/Layout/CookieConsentBar/CookieConsentBar.vue';
export default {
    name: 'terms',
    mixins: [AccountMixin],
    components: {
        Pdpa,
        NavBar,
        // CookieConsentBar
    },
    computed: {
        userType: function () {
            return this.$store.state.userType;
        }
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),
            lblCode: Locale.getLocaleCode(),
            navbarName: "",

            trackingService: new TrackingService(this),
            trackingScreenName: 'termsandcondition',
            trackingEventCategory: 'termsandcondition_page',
        };
    },
    created: function () {
        this.navbarName = this.lbl.terms.headline;
        this.trackingService.screenName(this.trackingScreenName);
        this.trackingService.event(this.trackingEventCategory, 'view_terms_and_condition', null, null);
    },
    methods: {
        clickBack: function () {
            this.$router.push('/profile');

            this.trackingService.event(this.trackingEventCategory, 'click_back', null, null);
        }
    }
}
</script>
<style lang="scss">
@import "@/components/PDPA/Page/pdpa.scss";
#terms_pdpa {
    
    padding: 0px 12px;
    #pdpa-headline {
        margin-bottom: 5px;
        text-align: left;
    }

    .pdpa-content {
        height: auto;
        min-height: 100%;
        margin-bottom: 0;
        border: none;
        border-radius: 0;
        overflow: hidden;
    }
}
</style>
